<template>
  <div class="time-container page-bg">
    <Header :headerTitle="resultList.licenseplate"></Header>
<!--    <Header backgroundColor="#cfcfcf !important" borderBottom="1px solid #cfcfcf">{{ resultList.licenseplate }}</Header>-->
<!--    <div class="license-number">
      <div class="dot dot-l"></div>
      {{resultList.licenseplate}}
      <div class="dot dot-r"></div>
    </div>-->
    <div class="main-container">
      <b-row class="time-info">
        <b-col cols="4">
          <p class="enter-time">{{ resultList.chargeInfo.totalPower }}</p>
          <p class="enter-text">已充电(度)</p>
        </b-col>
        <b-col cols="4">
          <p class="enter-time">{{ resultList.chargeInfo.chargeDurationStr }}</p>
          <p class="enter-text">充电时长</p>
        </b-col>
        <b-col cols="4">
          <p class="enter-time">{{ resultList.chargeInfo.chargeAmount }}</p>
          <p class="enter-text">充电费用(元)</p>
        </b-col>
      </b-row>
      <div class="countdown-panel">
        <div class="countdown">
          <img class="countdown-bg" :src="timeBG" width="200">
          <div class="countdown-circle" :style="{backgroundColor: circleColor}">
            <p style="font-size: 55px">
              {{resultList.chargeInfo.soc}}<span style="font-weight: bold;font-size: 20px;">%</span>
              <!-- <img
                class="countdown-tip"
                src="../../assets/img/gantanhao.png"
                width="15"
                v-show="resultList.isTimeout==2"
              >-->
            </p>
            <p style="font-size: 12px">
              <span class="countdown-circle-title">直流充电中</span>
              <br>
              <span class="countdown-circle-desc">充电桩数据更新</span>
            </p>
            <!--剩余时间 -->
          </div>
        </div>
      </div>
      <div class="panel">
        <h6 style="width: 100%; text-align: left">终端信息</h6>
        <div class="equipment-desc-container ">
          <div class="equipment-desc">终端编号: {{ orderDetail.parkingSpace.equipmentCode }}</div>
          <div v-if="orderDetail.parkingSpace.describe1" class="equipment-desc">{{ orderDetail.parkingSpace.describe1 }}</div>
          <div v-if="orderDetail.parkingSpace.describe2" class="equipment-desc">{{ orderDetail.parkingSpace.describe2 }}</div>
          <div v-if="orderDetail.parkingSpace.describe3" class="equipment-desc">{{ orderDetail.parkingSpace.describe3 }}</div>
        </div>
      </div>
      <div class="panel" style="margin-top:8px">
        <h6 style="width: 100%; text-align: left;">价格信息</h6>
        <div class="space-name">{{ orderDetail.chargeUnitAmount }}元/度</div>
      </div>
      <div class="footer-bg">
        <van-row gutter="12" class="footer-row" >
          <van-col span="12">
            <b-btn v-b-modal.modal-center class="default-btn" @click="goParking()">返回首页</b-btn>
          </van-col>
          <van-col span="12">
            <b-btn v-b-modal.modal-center class="primary-btn" @click="handleCharge">停止充电</b-btn>
          </van-col>
        </van-row>
<!--        <div class="footer-tip" @click="handleDontStopCharge">无法停止充电？</div>-->
      </div>
    </div>

    <b-modal ref="notice-stop-charge" id="notice-stop-charge" no-close-on-backdrop class="notice" static ok-title="确定"
             cancel-title="再等等" @ok="handleStopCharge(1)">
      <h5 style="margin-top: 12px"><b><strong>{{ noticeTitle }}</strong></b></h5>
      <p class="my-sm-6" style="margin-bottom:5px !important;padding:0 25px;font-size:14px;">
        {{ noticeInfo }}
      </p>
    </b-modal>

    <b-modal ref="notice-stop-charge-tip" id="notice-stop-charge-tip" no-close-on-backdrop class="notice" static hide-footer>
      <h5 style="margin-top: 12px"><b><strong>{{ noticeTitle }}</strong></b></h5>
      <p class="my-sm-6" style="margin-bottom:5px !important;padding:0 25px;font-size:16px;">
        停止充电中，请稍后拔枪，预计需要<span style="color: #0061B1"> {{ noticeInfo }} </span>，结束过程中拔枪会造成锁枪，并可能发生安全风险
      </p>
    </b-modal>

    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import {parkingTime} from "../../api/time.js";
import DateUtil from "../../utils/DateUtil";
import {orderStatus, manualLeave, orderListByDetails, stopCharge } from "@/api/order.js";
import {dateAdd, formatDate, hourtoMinute} from "@/utils/DateFomatUtil";
// import { userOrderStatus } from "../api/order.js";
export default {
  name: "Time",
  data() {
    return {
      circleColor: "#0066B1",
      circleTip: "",
      orderId: "", //订单Id
      resultList: {}, //数据
      actualInTime: "", //转换出来的进场时间
      appointTime: "", //转换成预约时间
      timeOutTime: "", //超时时间
      availableTime: "", //剩余时长
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "", //提示类型
      ostatus: null,
      chargeBtnTitle: '',
      orderDetail: undefined,
      noticeTitle: '',
      noticeInfo: '',
      chargingTime: 90
    };
  },
  mounted() {
    this.handleOrderDetail()
    this.loadParkingTime()
    this.orderStatus()
  },
  computed: {
      timeBG: function () {
        this.circleColor = "#0066B1";
        return require("../../assets/img/time-bg-blue.png");

        if (this.resultList.isTimeout == 2) {
          this.circleColor = "#0066B1";
          return require("../../assets/img/time-bg-blue.png");
        } else if (this.resultList.isTimeout == 1) {
          this.circleColor = "#D61C24";
          this.circleTip = this.$t('m.time.overtime');
          return require("../../assets/img/time-bg-red.png");
        }
      }
    },
  //加载事件
  created() {
    this.orderId = this.$route.params.orderId; //订单Id
    this.loadParkingTime()
  },
  methods: {
    goParking() {
      this.$router.push("/");
    },
    handleOrderDetail() {
      orderListByDetails({
        orderId: this.orderId
      }).then(res => {
        this.orderDetail = res.data.result;
      });
    },
    handleDontStopCharge() {
      this.$router.push("/chargeStop/" + this.resultList.chargeInfo.identCode);
    },
    handleCharge() {
      this.noticeTitle = '确定停止充电？'
      this.noticeInfo = ''
      this.$refs["notice-stop-charge"].show();
    },
    handleStopCharge() {
      const self = this
      self.chargingTime = 90

      stopCharge({
        orderId: this.orderId
      }).then(res => {
        if(res.data.status !== 200){
          // this.tipShow = "1" + Math.random() * 1000;
          this.message = res.data.message;
          this.tipType = "warning";
        }
      })

      this.noticeTitle = '温馨提示'
      this.noticeInfo = this.chargingTime + 's'
      this.$refs["notice-stop-charge-tip"].show();

      this.chargeInterval = setInterval(function () {
        if(self.chargingTime <= 0) {
          clearInterval(self.chargeInterval)
          self.$refs["notice-stop-charge-tip"].hide()

          self.tipShow = "1" + Math.random() * 1000;
          self.message = '停止充电超时, 请重试';
          self.tipType = "warning";
        }

        self.chargingTime = self.chargingTime - 1
        self.noticeInfo = self.chargingTime + 's'
      }, 1000);
    },
    //加载方法
    loadParkingTime: function () {
      parkingTime({
        orderId: this.orderId,
        chargeSeq: this.resultList && this.resultList.chargeInfo ? this.resultList.chargeInfo.chargeSeq : ''
      }).then(
          response => {
            if (response.data.status == 200) {
              this.resultList = response.data.result;

              if(this.resultList.chargeInfo && this.resultList.chargeInfo.chargeStatus === 4){
                this.$refs["notice-stop-charge-tip"].hide()
                this.$router.push("/chargeDetail/" + this.orderId + "/" + this.resultList.chargeInfo.chargeSeq);
              }

              //截取进场时间
              this.actualInTime = this.resultList.actualInTime.split(" ")[1];
              //转换预约时间
              this.appointTime = hourtoMinute(this.resultList.appointTime, this.$t('m.dataTime.hours'), this.$t('m.dataTime.minute'));
              //已超时和剩余时间字段转时间
            }
          }
      );
    },
    //刷新时间
    refresh: function () {
      this.loadParkingTime(); //方法刷新
      this.tipShow = "1" + Math.random() * 1000000;
      this.message = this.$t('m.time.refreshSuccess');
      this.tipType = "success";
    },
    goCharge () {
      if(!this.resultList.chargeInfo){
        this.$router.push("/charge/" + this.orderId);
      }
    },
    //手动离场
    handleManualLeave() {
      manualLeave({id: this.orderId}).then(response => {
        if (response.data.status != 200) {
          this.tipShow = "1" + Math.random() * 1000;
          this.tipType = "warning";
          this.message = "离场失败";
        }
      })
    },
    //轮询订单状态
    orderStatus() {
      let this_s = this;
      this.ostatus = setInterval(function () {
        this_s.loadParkingTime();
      }, 5000);
    }
  },
  destroyed() {
    if (this.ostatus != null) {
      clearInterval(this.ostatus);
    }
  }
};
</script>

<style scoped>
.time-container {
  height: 100%;
}
.license-number {
  position: absolute;
  top: 17px;
  left: 0px;
  right: 0px;
  max-width: 130px;
  height: 43px;
  margin: 0 auto;
  border: 1px solid #999999;
  font-size: 18px;
  font-family: BMWTypeGlobalPro-Light;
  text-align: center;
  line-height: 43px;
  border-radius: 10px;
}

.license-number .dot {
  width: 4px;
  height: 4px;
  background-color: black;
  border-radius: 50%;
  position: absolute;
  top: 0px;
  bottom: 0px;
  margin: auto;
}

.license-number .dot-l {
  left: 5px;
}

.license-number .dot-r {
  right: 5px;
}

.time-info {
  padding: 1rem 1.5rem;
  background: white;
}

.time-info .split {
  width: 50%;
  height: 50px;
  border-right: 1px solid #999999;
}

.time-info p {
  margin-bottom: 3px;
}

.time-info .enter-text {
  font-size: 14px;
}

.time-info .enter-time {
  font-size: 22px;
  color: #0066B1;
  font-weight: bold;
}

.countdown {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  position: relative;
  margin-bottom: 20px;
  background: white;
}

.countdown .countdown-bg {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0px;
  top: 0px;
  bottom: 0px;
  margin: auto;
}

.countdown .countdown-circle {
  width: 90%;
  height: 90%;
  border-radius: 50%;
  border: 5px solid white;
  position: absolute;
  z-index: 1;
  color: white;
  left: 0;
  right: 0px;
  top: 0px;
  bottom: 0px;
  margin: auto;
}

.countdown .countdown-circle .countdown-tip {
  position: relative;
  top: -2px;
}

.countdown .countdown-circle p:first-child {
  font-size: 96px;
  margin-bottom: 0px !important;
  position: absolute;
  top: 24px;
  left: 0;
  right: 0;
}

.countdown .countdown-circle p:last-child {
  font-size: 38px;
  margin-bottom: 0px !important;
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
}


.main-container .button-charge {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 30px;
}
.main-container .button-charge button {
  background-color: #0066B1 !important;
  margin-bottom: 10px;
  width: 120px;
}
.main-container .button button {
  background-color: #0066B1 !important;
  margin-bottom: 10px;
  width: 120px;
}

.station-addr {
  color: #0066B1;
  margin-top: 20px;
  font-size: 14px;
  /* position: absolute; */
  left: 0px;
  right: 0px;
  margin-bottom: 7px;
}

.station-addr span {
  padding: 2px;
  border: 1px solid;
  border-radius: 5px;
  border-right: none;
}

.station-le-info {
  /* position: absolute; */
  margin-bottom: 0px;
  font-size: 14px;
  bottom: 20px;
  left: 0px;
  right: 0px;
}

.station-le-info span {
  color: #0066B1;
}

#chaoshi {
  font-size: 12px;
  display: block;
  font-family: "宋体";
}
.equipment-desc-container {
  display: flex !important;
  justify-content: left;
  align-items: center;
  flex-direction: column;
  margin: 8px 0 16px 0;
}
.equipment-desc {
  width: 100%;
  text-align: left;
}
.space-name {
  margin-top: 8px;
  font-size: 24px;
  font-weight: 500;
  color: #0061B1;
  line-height: 24px;
  width: 100%;
  text-align: left;
}
.footer-tip {
  margin-top: 8px;
  width: 100%;
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #0061B1;
  line-height: 14px;
  text-align: left;
}
</style>
<style>
.page-bg .main-container {
  padding: 0px;

}
.page-bg .countdown-panel {
  background: white;
  padding-bottom: 20px;
  border-bottom: 1px solid #F5F5F7;
}
.countdown-circle-title{
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid white;
  width: 70%;
  display: inline-block;
}
.countdown-circle-desc{
  margin-top: 4px;
  display: inline-block
}

.footer-bg{
  /* position: fixed; */
  width: 100%;
  bottom: 5%;
  padding: 0px 4%;
  margin-top: 3%;

}
.footer-bg .footer-row .primary-btn{
  background-color: #0061B1;
  color: #FFFFFF;
  width: 100%;
}
.footer-bg .footer-row .default-btn{
  background-color: white;
  color: #352f2f;
  width: 100%;
}

</style>
